import {Component, ElementRef, ViewChild, ViewEncapsulation, inject, Input} from '@angular/core';
import {map, take} from 'rxjs';
import {NgeExplorerConfig} from '../../shared/types';
import {ExplorerService} from '../../services/explorer.service';
import {ViewSwitcherComponent} from '../view-switcher/view-switcher.component';
import {CONFIG} from '../../shared/providers';
import {AsyncPipe} from '@angular/common';
import {TablerIconsModule} from 'angular-tabler-icons';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MaterialModule} from '../../material.module';


@Component({
  selector: 'nxe-menu-bar',
  templateUrl: './menu-bar.component.html',
  styleUrls: ['./menu-bar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [ViewSwitcherComponent, AsyncPipe, TablerIconsModule, MaterialModule, MatButtonModule, MatIconModule, MatButtonToggleModule],
})
export class MenuBarComponent {
  @Input() showSwitcher: boolean = true;
  @Input() showSendFile: boolean = false;
  @Input() showEditFile: boolean = false;
  @Input() showViewFile: boolean = true;
  @ViewChild('uploader', {static: true}) uploader!: ElementRef;

  protected explorerService: ExplorerService = inject(ExplorerService);
  protected config: NgeExplorerConfig = inject(CONFIG);

  protected featDelete = this.config.features?.delete;
  protected featUpload = this.config.features?.upload;
  protected featDownload = this.config.features?.download;
  protected featRename = this.config.features?.rename;
  protected featCreateDir = this.config.features?.createDir;
  protected featViewFile = this.config.features?.viewFile;
  protected featSendFile = this.config.features?.sendFile;

  protected canDownload$ = this.explorerService.selection$.pipe(map((n) => n.length === 1 && n[0].isLeaf));
  protected canDelete$ = this.explorerService.selection$.pipe(map((n) => n.length > 0));
  protected canRename$ = this.explorerService.selection$.pipe(map((n) => n.length === 1));
  protected canView$ = this.explorerService.selection$.pipe(map((n) => n.length === 1 && n[0].isLeaf));
  protected canSendFile$ = this.explorerService.selection$.pipe(map((n) => n.length === 1 && n[0].isLeaf));
  protected canEditFile$ = this.explorerService.selection$.pipe(map((n) => n.length === 1 && n[0].isLeaf));

  createDir() {
    const name = prompt('Enter new name');
    if (name) {
      this.explorerService.createDir(name);
    }
  }

  refresh() {
    this.explorerService.refresh();
  }

  rename() {
    this.explorerService.selection$
      .pipe(
        take(1),
        map((n) => n[0])
      )
      .subscribe((node) => {
        const oldName = node.name;
        const newName = prompt('Enter new name', oldName);
        if (newName) {
          this.explorerService.rename(newName);
        }
      });
  }

  remove() {
    if (confirm('Are you sure you want to delete the selected files?')) {
      this.explorerService.remove();
    }
  }

  openUploader() {
    this.uploader.nativeElement.click();
  }

  viewFile() {
    this.explorerService.viewFile();
  }

  sendFile() {
    this.explorerService.sendFile();
  }

  editFile() {
    this.explorerService.editFile();
  }

  handleFiles(event: Event) {
    const files = (event.target as HTMLInputElement).files;
    if (!files || files.length === 0) {
      return;
    }
    this.explorerService.upload(files);
    this.uploader.nativeElement.value = '';
  }

  download() {
    this.explorerService.download();
  }
}
